// --------------------------------------------------------------
// Created On: 2022-05-02
// Author: Zachary Thomas
//
// Last Modified: 2025-10-16
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import Spinner from "../../components/Spinner/Spinner";

// Very simple page that represents the first place where the mobile app lands when starting the application.
// The mobile app will redirect off of this page when it has loaded user info and tokens into the web app local storage.
export default function MobileAppLandingPage(): Component {
  return <Spinner loading={true} />;
}
